<template>
  <div class="add-user-panel" v-if="dropDownRender">
    <div class="add-user-panel__header">
      <div class="add-user-panel__header-row">
        <div class="add-user-panel__title">{{ title }}</div>
        <IconButton
          size="super-small"
          color="secondary"
          icon="close-icon"
          @click="$emit('close')"
        />
      </div>
      <!-- <div class="form__field">
        <div class="form__field-label">מסגרות</div>
        <CustomThreeSelect
          v-model="filter.institutionIds"
          :options="institutions"
          :multiple="false"
          :class="'form__field-select '"
        />
      </div> -->
      <ThreeSelectSchools
        v-if="viewInstitutionsSelect"
        :objAllItem="instForFilterSchool"
        :multiple="false"
        :inst_types="inst_types"
        :regions="regions"
        :selectedInst="selectedInst"
        :administration_select="administration_select"
        :class="'form__field-select ThreeSelectSchoolsDropDown'"
        @search="searchInstitutions"
        @select="selectInstitution"
        @filtered="filtered"
      />
      <div class="add-user-panel__search">
        <div class="add-user-panel__search-icon">
          <icon name="search-icon" />
        </div>
        <input
          type="text"
          v-model="search"
          class="add-user-panel__search-input"
          placeholder="חיפוש"
        />
        <IconButton
          class="add-user-panel__filter-button"
          size="super-small"
          color="secondary"
          icon="filter-icon"
          @click="active_filter = !active_filter"
        />
        <div class="filter-block" :class="{ active: active_filter }">
          <div class="filter-block__header">
            <h4 class="filter-block__title" style="color: #929baa">מסנן</h4>
            <button class="filter-block__clear-button" @click="clearFilter">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.3158 4H13.6842V7.5H20V11H4V7.5H10.3158V4Z"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 20H19V11H5V20Z"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.5 20V16"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 20V16"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.5 20V16"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.94727 20H17.0525"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              נקה הכל
            </button>
          </div>
          <div class="filter-block__body" @click.stop>
            <div class="form__field mb-2">
              <!-- <div class="form__field" v-if="switcher === 1">
                <div class="form__field-label">קבוצה</div>
                <CustomThreeSelect
                  v-model="userTab"
                  :options="userTabs"
                  :multiple="false"
                  :valueFormat="'object'"
                  :class="'form__field-select '"
                />
              </div> -->
              <div class="form__field" v-if="switcher === 1">
                <div class="form__field-label">קבוצה</div>
                <CustomThreeSelect
                  v-model="selectedProjectGroup"
                  :options="projectGroupsForSelect"
                  :multiple="false"
                  :valueFormat="'object'"
                  class="form__field-select"
                />
              </div>
              <!-- <div class="form__field" v-if="switcher === 1">
                <div class="form__field-label">כיתה</div>
                <CustomThreeSelect
                  v-model="userTabData"
                  :options="userTabsData"
                  :valueFormat="'object'"
                  :multiple="false"
                  :class="'form__field-select '"
                />
              </div> -->
              <div class="form__field" v-if="switcher === 1">
                <div class="form__field-label">כיתה</div>
                <CustomThreeSelect
                  v-model="selectedProjectGroupClass"
                  :options="projectGroupClasses"
                  :valueFormat="'object'"
                  :multiple="false"
                  class="form__field-select"
                />
              </div>
              <div class="form__field" v-if="switcher === 1">
                <div class="form__field-label">שכבה</div>
                <CustomThreeSelect
                  v-model="selectedProjectGroupLevel"
                  :options="projectGroupLevels"
                  :multiple="true"
                  class="form__field-select"
                />
              </div>
              <div class="form__field" v-if="switcher === 2">
                <div class="form__field-label">כיתה</div>
                <CustomThreeSelect
                  v-model="filter.department_id"
                  :options="departments"
                  :multiple="false"
                  :class="'form__field-select '"
                />
              </div>
              <div class="form__field" v-if="switcher === 2">
                <div class="form__field-label">כיתה</div>
                <CustomThreeSelect
                  v-model="filter.position_id"
                  :disabled="!filter.department_id"
                  :options="positions"
                  :multiple="false"
                  :class="'form__field-select '"
                />
              </div>
              <!-- <div class="form__field">
                <div class="form__field-label">רשויות</div>
                <CustomThreeSelect
                  v-model="filter.districtAdministrationIds"
                  :options="administration_select"
                  :multiple="true"
                  :class="'form__field-select '"
                />
              </div> -->
              <!-- <div class="form__field">
                <div class="form__field-label">מסגרות</div>
                <CustomThreeSelect
                  v-model="filter.institutionIds"
                  :options="institutions"
                  :multiple="true"
                  :class="'form__field-select '"
                />
              </div> -->
              <div class="form__row">
                <button
                  class="form__field-btn btn btn--blue"
                  @click="filtering"
                >
                  חפש
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sub-group-add-student-modal__fields" v-if="!onlyStudent">
        <div class="sub-group-add-student-modal__field">
          <input
            type="radio"
            :value="1"
            name="group-6"
            v-model="switcher"
            class="sub-group-add-student-modal__field-input"
            checked
          />
          <div class="sub-group-add-student-modal__field-label">תלמידים</div>
        </div>
        <div class="sub-group-add-student-modal__field">
          <input
            type="radio"
            :value="2"
            name="group-6"
            v-model="switcher"
            class="sub-group-add-student-modal__field-input"
          />
          <div class="sub-group-add-student-modal__field-label">עובדים</div>
        </div>
      </div>
    </div>
    <div class="add-user-panel__body" v-if="switcher === 1">
      <div class="add-user-panel__group-header">
        <CheckboxNew
          :check="isGroupSelected(studentList)"
          @checkedElem="selectGroup(studentList)"
        />
        <span class="text-check">({{ this.students_id.length }} נבחרו)</span>
      </div>
      <div class="add-user-panel__group-body">
        <div class="add-user-panel__group-list">
          <div
            class="add-user-panel__group-item"
            v-for="student in studentList"
            :class="[
              {
                expired_delay:
                  student.exit_permission_user_statuses &&
                  student.exit_permission_user_statuses.length > 0 &&
                  student.exit_permission_user_statuses[0].status ===
                    'expired_delay',
                active_use:
                  student.exit_permission_user_statuses &&
                  student.exit_permission_user_statuses.length > 0 &&
                  student.exit_permission_user_statuses[0].status ===
                    'active_use',
                active_green:
                  student.exit_permission_user_statuses &&
                  student.exit_permission_user_statuses.length > 0 &&
                  student.exit_permission_user_statuses[0].status === 'active'
              }
            ]"
            :key="student.id"
          >
            <CheckboxNew
              :check="isSelected(student)"
              @checkedElem="selectUser(student)"
            />
            <div class="add-user-panel__group-item-avatar">
              <img :src="student.image_path" alt="" v-avatar-placeholder />
            </div>
            <div class="add-user-panel__group-item-name">
              <div>{{ student.name + ' ' + student.last_name }}</div>
              <div
                class="student_class-and-group"
                v-if="student.class_or_position && student.group_or_department"
              >
                <div>{{ student.class_or_position }}</div>
                ,
                <div>{{ student.group_or_department }}</div>
              </div>
              <div
                class="student_class-and-group"
                v-if="student.class_or_position && !student.group_or_department"
              >
                <div>{{ student.class_or_position }}</div>
              </div>
              <div
                class="student_class-and-group"
                v-if="!student.class_or_position && student.group_or_department"
              >
                {{ student.group_or_department }}
              </div>
            </div>
            <div
              class="status__image"
              v-if="
                student.exit_permission_user_statuses &&
                student.exit_permission_user_statuses.length > 0 &&
                student.exit_permission_user_statuses[0].status ===
                  'expired_delay'
              "
            >
              <img src="/images/expired-delay.svg" />
            </div>
            <div
              class="status__image"
              v-if="
                student.exit_permission_user_statuses &&
                student.exit_permission_user_statuses.length > 0 &&
                student.exit_permission_user_statuses[0].status === 'active_use'
              "
            >
              <img src="/images/active-use.svg" />
            </div>
          </div>
          <PaginationButton
            v-if="pageList < last_page"
            :countUsers="totalStudents"
            :view-count="viewCount"
            @clickPagination="clickPagination"
          ></PaginationButton>
        </div>
      </div>
    </div>
    <div class="add-user-panel__body" v-if="switcher === 2">
      <div class="add-user-panel__group-header">
        <CheckboxNew
          :check="isGroupSelected(workerList)"
          @checkedElem="selectGroup(workerList)"
        />
        <span class="text-check">({{ this.students_id.length }} נבחרו)</span>
      </div>
      <div class="add-user-panel__group-body">
        <div class="add-user-panel__group-list">
          <div
            class="add-user-panel__group-item"
            v-for="student in workerList"
            :key="student.id"
          >
            <CheckboxNew
              :check="isSelected(student)"
              @checkedElem="selectUser(student)"
            />
            <div class="add-user-panel__group-item-avatar">
              <img :src="student.image_path" alt="" v-avatar-placeholder />
            </div>
            <div class="add-user-panel__group-item-name">
              {{ student.name + ' ' + student.last_name }}
            </div>
          </div>
          <PaginationButton
            v-if="pageList < last_page"
            :countUsers="totalStudents"
            :view-count="viewCount"
            @clickPagination="clickPagination"
          ></PaginationButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxNew from '@/Components/UI/Form/CheckBoxModal.vue';
import IconButton from '@/Components/UI/Buttons/IconButton.vue';
import checkBoxComponent from '@/mixins/checkBoxComponent.js';
import axios from 'axios';
import { mapState } from 'vuex';
import { myPlaginDebounce } from '@/Plugins/helper';
import PaginationButton from '@/Components/UI/Buttons/PaginationButton.vue';
import CustomThreeSelect from '@/Components/UI/Form/CustomThreeSelect.vue';
import ThreeSelectSchools from '@/Components/UI/Form/ThreeSelectSchools.vue';

export default {
  components: {
    IconButton,
    CheckboxNew,
    PaginationButton,
    CustomThreeSelect,
    ThreeSelectSchools
  },
  mixins: [checkBoxComponent],
  props: {
    title: {
      type: String,
      default: 'הוספת משתמשים'
    },
    dropDownRender: {
      type: Boolean
    },
    viewInstitutionsSelect: {
      type: Boolean,
      default: false
    },
    group_id: {
      type: [Number, String],
      default: ''
    },
    project_id: {
      type: [Number, String],
      default: ''
    },
    user_type: Number,
    administration_select: Array,
    filter_classes: Array,
    filter_groups: Array,
    institutions: Array,
    departments: Array,
    onlyStudent: Boolean,
    contextInstitutionId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      filter: {
        districtAdministrationIds: [],
        institutionIds: [],
        student_group_id: null,
        student_class_id: null,
        department_id: null,
        position_id: null
      },
      userTab: null,
      userTabData: null,
      instForFilterSchool: [],
      selectedInst: {},
      inst_types: [],
      regions: [],
      positions: [],

      switcher: 1,
      pageList: 1,
      totalStudents: 0,
      viewCount: 0,
      last_page: 1,
      category: 'student-list',
      checkedAll: false,
      active_filter: false,
      categories: [],
      studentList: [],
      workerList: [],
      userTabs: [],
      projectGroupClasses: [],
      selectedProjectGroupClass: null,
      projectGroupsForSelect: [],
      selectedProjectGroup: null,
      projectGroupLevels: [],
      selectedProjectGroupLevel: [],
      userTabsData: [],
      users: [],
      search: '',
      search_inst: '',
      params_user: {
        id: 'student-list',
        slug: 'student-list',
        title: 'תלמידים',
        search: ' '
      }
    };
  },

  computed: {
    ...mapState({
      selectedCampus: s => s.settings.selectedCampus
    })
  },
  watch: {
    'filter.department_id'(newValue, oldValue) {
      if (newValue) {
        this.getPositions();
      }
      // Здесь можно выполнить какие-то действия при изменении department_id
      // console.log('department_id изменился с', oldValue, 'на', newValue);
    },
    userTab(val) {
      this.userTabData = null;
      this.getUserTabData(val);
    },
    search: myPlaginDebounce(function (newVal) {
      this.pageList = 1;
      this.getUsersSearch();
    }, 1300),
    switcher(val) {
      if (val === 1) {
        this.workerList = [];
      }
      if (val === 2) {
        this.studentList = [];
      }
      this.last_page = 1;
      this.viewCount = 0;
      this.totalStudents = 0;
      this.pageList = 1;
      this.getUsers();
    },
    contextInstitutionId() {
      this.getProjectGroupClasses();
      this.getProjectGroupsForSelect();
    }
  },
  async mounted() {
    await this.getInstitutionsForFilterSchool('', {});
    this.getUsers();
    this.getProjectGroupClasses();
    this.getProjectGroupsForSelect();
    this.getProjectGroupLevels();
    this.getRegion();
    this.getIstitutType();
    // if (this.dropDownRender) {
    //   this.getCategories();
    //   this.getUsers(this.params_user);
    // }
  },
  methods: {
    mergeStudentListInstitutionId(params) {
      if (this.group_id) {
        return;
      }
      const fromInst =
        this.selectedInst && this.selectedInst.id
          ? Number(this.selectedInst.id)
          : null;
      const fromCtx =
        this.contextInstitutionId != null && this.contextInstitutionId !== ''
          ? Number(this.contextInstitutionId)
          : null;
      const instId =
        fromInst && !Number.isNaN(fromInst) && fromInst > 0
          ? fromInst
          : fromCtx && !Number.isNaN(fromCtx) && fromCtx > 0
          ? fromCtx
          : null;
      if (instId) {
        params.institution_id = instId;
      }
    },
    filterDropdownInstitutionParams() {
      const params = {};
      if (this.selectedInst && this.selectedInst.id) {
        const n = Number(this.selectedInst.id);
        if (!Number.isNaN(n) && n > 0) {
          params.institution_id = n;
          return params;
        }
      }
      if (
        this.contextInstitutionId != null &&
        this.contextInstitutionId !== ''
      ) {
        const n = Number(this.contextInstitutionId);
        if (!Number.isNaN(n) && n > 0) {
          params.institution_id = n;
        }
      }
      return params;
    },
    searchInstitutions(value) {
      console.log(value);
      this.getInstitutionsForFilterSchool(value);
      this.search_inst = value;
    },
    async getIstitutType() {
      try {
        const respons = await this.$service.retrieve(
          this.$services.administrationResours.institution_dictionary_by_slug,
          {
            params: {
              slug: 'institution_type'
            }
          }
        );
        this.inst_types = respons.data.data.children;
      } catch (error) {
        console.log(error);
      }
    },
    async getRegion() {
      try {
        const respons = await this.$service.retrieve(
          this.$services.administrationResours.institution_dictionary_by_slug,
          {
            params: {
              slug: 'region'
            }
          }
        );
        this.regions = respons.data.data.children;
      } catch (error) {
        console.log(error);
      }
    },
    selectInstitution(id, item) {
      this.userTab = null;
      this.userTabData = null;
      this.selectedInst = item;
      this.pageList = 0;
      this.getStudents();
      this.getUserTabs(item.id);
      this.getProjectGroupClasses();
      this.getProjectGroupsForSelect();
    },
    async getUserTabs(id) {
      try {
        const respons = await axios.get(
          '/api/main-info/student-list/get-user-tabs',
          {
            params: {
              institution_id: id
            }
          }
        );
        this.userTabs = respons.data.data.map(el => {
          return { ...el, label: el.title };
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getUserTabData(item) {
      console.log(item, 'getUserTabData');
      const params = {
        type: item.type,
        institution_id: this.selectedInst.id
      };
      if (item.type == 3) {
        params.board_id = item.id;
      }
      try {
        const respons = await axios.get(
          '/api/main-info/student-list/get-user-tab-data',
          {
            params
          }
        );
        this.userTabsData = respons.data.data.map(el => {
          return { ...el, label: el.title };
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getProjectGroupClasses() {
      try {
        const response = await axios.get(
          '/api/main-info/filters/project-group-classes',
          { params: this.filterDropdownInstitutionParams() }
        );

        this.projectGroupClasses = response.data.data.map(el => ({
          ...el,
          label: el.title,
          value: el.id
        }));
      } catch (e) {
        console.log(e);
      }
    },
    async getProjectGroupsForSelect() {
      try {
        const response = await axios.get(
          '/api/main-info/filters/students-tab/get-student-groups',
          { params: this.filterDropdownInstitutionParams() }
        );

        this.projectGroupsForSelect = response.data.data.map(el => ({
          ...el,
          label: el.title,
          value: el.id
        }));
      } catch (e) {
        console.log(e);
      }
    },
    async getProjectGroupLevels() {
      try {
        const response = await axios.get(
          'api/main-info/student-list/filters/class-levels'
        );

        this.projectGroupLevels = response.data.data.map(el => ({
          ...el,
          label: el.title,
          value: el.id
        }));
      } catch (e) {
        console.log(e);
      }
    },
    filtered(filter) {
      this.getInstitutionsForFilterSchool(this.search_inst, filter);
    },
    async getInstitutionsForFilterSchool(search, filter) {
      try {
        const response = await axios.get(
          '/api/main-info/student-list/get-institutions',
          {
            params: {
              search,
              ...filter
            }
          }
        );
        this.instForFilterSchool = response.data.data;
        this.selectedInst = this.instForFilterSchool[0];
      } catch (e) {
        console.log(e);
      }
    },
    getPositions() {
      axios
        .get('/api/departments/' + this.filter.department_id + '/positions')
        .then(res => {
          const array = res.data.data.map(el => {
            return { ...el, label: el.name };
          });
          this.positions = array;
        });
    },
    clearFilter() {
      this.filter = {
        districtAdministrationIds: [],
        institutionIds: [],
        student_group_id: null,
        student_class_id: null,
        department_id: null,

        position_id: null
      };
      this.selectedProjectGroupClass = null;
      this.selectedProjectGroup = null;
      this.selectedProjectGroupLevel = [];
      this.filtering();
    },
    filtering() {
      this.pageList = 1;
      if (this.switcher === 1) {
        this.getStudentsSearch();
      }
      if (this.switcher === 2) {
        this.getWorkersSearch();
      }
    },
    clickPagination() {
      if (this.pageList < this.last_page) {
        this.pageList += 1;
        this.getUsers();
      }
    },
    viewUsers(user) {
      if (user && user.view === true) {
        this.$set(user, 'view', false);
      } else {
        this.$set(user, 'view', true);
      }
    },
    selectCategory(id, title, slug) {
      this.params_user = {
        id,
        title,
        slug
      };
      this.getUsers(this.params_user);
    },
    async getStudents() {
      const params = {};
      if (this.userTab && this.userTab.type == 1) {
        params.student_group_id = this.userTabData.id;
      }
      if (this.userTab && this.userTab.type == 2) {
        params.student_class_id = this.userTabData.id;
      }
      if (this.userTab && this.userTab.type == 3) {
        params.student_board_column_id = this.userTabData.id;
      }
      if (this.group_id) {
        params.group_id = this.group_id;
        params.user_type = this.user_type ? this.user_type : '';
        params.institution_id =
          this.selectedInst && this.selectedInst.id ? this.selectedInst.id : 0;
      }
      if (!this.group_id && this.project_id) {
        params.project_id = this.project_id ? this.project_id : '';
        params.user_type = this.user_type ? this.user_type : '';
      }
      this.mergeStudentListInstitutionId(params);

      try {
        const respons = await axios.get(
          '/api/main-info/multi-users-select/student-list',
          {
            params: {
              campus_id: this.selectedCampus.id,
              page: this.pageList,
              search: this.search,

              ...params
              // institutionIds: this.filter.institutionIds,
              // districtAdministrationIds: this.filter.districtAdministrationIds
            }
          }
        );
        if (respons) {
          this.studentList = [...this.studentList, ...respons.data.data];
          this.last_page = respons.data.meta.last_page;
          this.totalStudents = respons.data.meta.total;
          this.viewCount = respons.data.meta.to;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getWorkers() {
      const params = {};
      if (this.group_id) {
        params.group_id = this.group_id;
        params.user_type = this.user_type ? this.user_type : '';
        params.institution_id =
          this.selectedInst && this.selectedInst.id ? this.selectedInst.id : 0;
      }
      if (!this.group_id && this.project_id) {
        params.project_id = this.project_id ? this.project_id : '';
        params.user_type = this.user_type ? this.user_type : '';
        params.institution_id =
          this.selectedInst && this.selectedInst.id ? this.selectedInst.id : 0;
      }
      try {
        const respons = await axios.get(
          '/api/main-info/multi-users-select/worker-list',
          {
            params: {
              campus_id: this.selectedCampus.id,
              page: 1,
              search: this.search,
              institutionIds: this.filter.institutionIds,
              districtAdministrationIds: this.filter.districtAdministrationIds,
              project_id: this.project_id ? this.project_id : '',
              position_id: this.filter.position_id,
              department_id: this.filter.department_id,
              group_id: this.group_id ? this.group_id : '',
              user_type: this.user_type ? this.user_type : ''
            }
          }
        );
        if (respons) {
          this.workerList = [...this.workerList, ...respons.data.data];
          this.last_page = respons.data.meta.last_page;
          this.totalStudents = respons.data.meta.total;
          this.viewCount = respons.data.meta.to;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getStudentsSearch() {
      const params = {};
      if (this.userTab && this.userTab.type == 1) {
        params.student_group_id = this.userTabData.id;
      }
      if (this.userTab && this.userTab.type == 2) {
        params.student_class_id = this.userTabData.id;
      }
      if (this.userTab && this.userTab.type == 3) {
        params.student_board_column_id = this.userTabData.id;
      }
      if (this.selectedProjectGroupClass) {
        params.student_class_id = this.selectedProjectGroupClass.id;
      }

      if (this.selectedProjectGroup) {
        params.student_group_id = this.selectedProjectGroup.id;
      }

      const levels = Array.isArray(this.selectedProjectGroupLevel)
        ? this.selectedProjectGroupLevel
        : [];

      params.class_levels_ids = levels
        .map(l => {
          if (l && typeof l === 'object') {
            return l.id !== undefined && l.id !== null ? l.id : l.value;
          }
          return l;
        })
        .filter(v => v !== undefined && v !== null && v !== '');
      if (this.group_id) {
        params.group_id = this.group_id;
        params.user_type = this.user_type ? this.user_type : '';
        params.institution_id =
          this.selectedInst && this.selectedInst.id ? this.selectedInst.id : 0;
      }
      if (!this.group_id && this.project_id) {
        params.project_id = this.project_id ? this.project_id : '';
        params.user_type = this.user_type ? this.user_type : '';
      }
      if (!this.group_id) {
        const fromInst =
          this.selectedInst && this.selectedInst.id
            ? Number(this.selectedInst.id)
            : null;
        const fromCtx =
          this.contextInstitutionId != null && this.contextInstitutionId !== ''
            ? Number(this.contextInstitutionId)
            : null;
        const instId =
          fromInst && !Number.isNaN(fromInst) && fromInst > 0
            ? fromInst
            : fromCtx && !Number.isNaN(fromCtx) && fromCtx > 0
            ? fromCtx
            : null;
        if (instId) {
          params.institution_id = instId;
        }
      }
      try {
        const respons = await axios.get(
          '/api/main-info/multi-users-select/student-list',
          {
            params: {
              campus_id: this.selectedCampus.id,
              page: this.pageList,
              search: this.search,

              ...params
              // student_class_id: this.filter.student_class_id,
              // student_group_id: this.filter.student_group_id
              // institutionIds: this.filter.institutionIds,
              // districtAdministrationIds: this.filter.districtAdministrationIds
            }
          }
        );
        if (respons) {
          this.studentList = respons.data.data;
          this.last_page = respons.data.meta.last_page;
          this.totalStudents = respons.data.meta.total;
          this.viewCount = respons.data.meta.to;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getWorkersSearch() {
      try {
        const respons = await axios.get(
          '/api/main-info/multi-users-select/worker-list',
          {
            params: {
              campus_id: this.selectedCampus.id,
              page: 1,
              search: this.search,
              institutionIds: this.filter.institutionIds,
              group_id: this.group_id ? this.group_id : '',
              project_id: this.project_id ? this.project_id : '',
              districtAdministrationIds: this.filter.districtAdministrationIds,
              position_id: this.filter.position_id,
              user_type: this.user_type ? this.user_type : '',
              department_id: this.filter.department_id
            }
          }
        );
        if (respons) {
          this.workerList = respons.data.data;
          this.last_page = respons.data.meta.last_page;
          this.totalStudents = respons.data.meta.total;
          this.viewCount = respons.data.meta.to;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getUsers(obj) {
      if (this.switcher === 1) {
        this.getStudents();
      }
      if (this.switcher === 2) {
        this.getWorkers();
      }
    },
    getUsersSearch() {
      if (this.switcher === 1) {
        this.getStudentsSearch();
      }
      if (this.switcher === 2) {
        this.getWorkersSearch();
      }
    }
    // async getCategories() {
    //   try {
    //     const respons = await axios.get('/api/main-info/get-users-categories', {
    //       params: {
    //         campus_id: this.selectedCampus.id
    //       }
    //     });
    //     this.categories = respons.data.data.map(el => {
    //       return { ...el, text: el.title };
    //     });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
.ThreeSelectSchoolsDropDown {
  margin-bottom: 16px;
}

.status__image {
  position: absolute;
  left: 12px;
}

.expired_delay {
  background-color: #ffe8e6;
}

.active_use {
  background: #e5f2ff;
}

.active_green {
  background: #e6ffea;
}

.student_class-and-group {
  font-size: 12px;
  font-weight: 400;
  color: rgba(90, 111, 149, 1);
  display: flex;
  direction: ltr;
  align-content: flex-end;
  align-items: flex-start;
  justify-content: flex-end;
}

.form__field-btn {
  width: 100%;
}

.text-check {
  font-size: 14px;
  line-height: 24px;
  text-align: right;
  color: #7fbfff;
}

.sub-group-add-student-modal {
  &:not(:last-child) {
    margin-bottom: 32px;
  }

  &__title {
    color: #38455d;
    text-align: right;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    /* 125% */
    margin-bottom: 16px;
  }

  &__label {
    color: #38455d;
    text-align: right;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    /* 142.857% */
    margin-bottom: 4px;
  }

  &__row {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  &__fields {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 4px;
    border-radius: 8px;
    border: 1px solid #e3e7ee;
    margin-bottom: 8px;
  }

  &__field {
    position: relative;
    cursor: pointer;
  }

  &__field-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 1;

    &:checked + .sub-group-add-student-modal__field-label {
      background-color: #eef7ff;
      color: #409fff;
    }
  }

  &__field-label {
    color: #38455d;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    transition: 0.3s;
    border-radius: 4px;
    height: 40px;
  }
}

.filter-block {
  position: absolute;
  box-shadow: 0px 2px 4px 0px rgba(56, 69, 93, 0.04),
    0px 4px 12px -2px rgba(56, 69, 93, 0.12);
  top: 58px;
  left: 0;
  width: 100%;
  min-height: 262px;
  background-color: #fff;
  padding: 12px 12px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
  opacity: 0;
  transition: 0.3s;
  pointer-events: none;

  &.active {
    opacity: 1;
    pointer-events: all;
  }

  &__close-button {
    display: flex;
    width: 24px;
    height: 24px;
    border: none;
    background-color: transparent;
    margin-bottom: 8px;
    cursor: pointer;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  &__clear-button {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #929baa;
    border: none;
    background-color: transparent;
    padding: 8px 4px;
  }

  &__body {
    margin-bottom: auto;
  }
}

.add-user-panel {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 692px;
  width: 300px;
  height: 100%;
  border-right: 1px solid var(--dark-grey-tints-light-grey, #e3e7ee);
  background: var(--background-white, #fff);
  box-shadow: 0px 4px 12px -4px rgba(56, 69, 93, 0.04),
    0px 8px 20px -4px rgba(56, 69, 93, 0.08);

  &__group-list {
    // max-height: 500px;
    overflow: auto;
  }

  &__header {
    width: 100%;
    padding: 16px;
    background: var(--background-white, #fff);
    z-index: 1;
  }

  &__header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  &__title {
    color: var(--dark-grey-tints-main-dark, #38455d);
    text-align: right;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }

  &__search {
    position: relative;
    margin-bottom: 16px;
  }

  &__search-icon {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    stroke: var(--dark-grey-tints-main-grey, #8e9ebb);
  }

  &__search-input {
    border-radius: 8px;
    border: 1px solid var(--dark-grey-tints-light-grey, #e3e7ee);
    background: var(--background-white, #fff);
    height: 40px;
    width: 100%;
    padding: 0 44px 0 44px;
    overflow: hidden;
    color: #38455d;
    font-size: 14px;
    font-family: Rubik;
    line-height: 24px;

    &::placeholder {
      color: var(--dark-grey-tints-main-grey, #8e9ebb);
    }

    &:focus {
      outline: none;
    }
  }

  &__filter-button {
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
  }

  &__selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__amount {
    border-radius: 16px;
    background: var(--background-extra-grey, #f7f8fa);
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    color: var(--dark-grey-tints-main-dark, #38455d);
    font-size: 14px;
    line-height: 24px;
    stroke: #8e9ebb;

    span {
      min-width: 24px;
      text-align: center;
    }
  }

  &__body {
    overflow-y: auto;
    height: calc(100% - 185px);
  }

  &__group-header {
    border-bottom: 1px solid var(--dark-grey-tints-light-grey, #e3e7ee);
    background: var(--background-extra-grey, #f7f8fa);
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--dark-grey-tints-main-dark, #38455d);
    text-align: right;
    font-size: 14px;
    line-height: 24px;
    cursor: pointer;
    position: relative;

    .toggle-button {
      position: absolute;
      transform: translateY(-50%);
      left: 16px;
    }

    .no-rotate {
      top: 50%;
    }

    .rotate {
      transform: scaleY(-1);
    }
  }

  &__group-item {
    padding: 8px 16px 8px 16px;
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--dark-grey-tints-main-dark, #38455d);
    text-align: right;
    font-size: 14px;
    line-height: 24px;

    &:not(:last-child) {
      border-bottom: 1px solid var(--dark-grey-tints-light-grey, #e3e7ee);
    }
  }

  &__group-item-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }
}

@media (max-width: 1023px) {
  .add-user-panel {
    left: 486px;
  }
}

@media (max-width: 786px) {
  .add-user-panel {
    left: 0;
    width: 100%;
  }
}
</style>
